"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var redux_1 = require("redux");

var actions_1 = require("./actions");

var helpers_1 = require("./helpers");

exports.reduxSdkReducer = redux_1.combineReducers({
  initialized: helpers_1.createReducer(actions_1.ReduxSdkActionTypes.SetInitialized),
  connected: helpers_1.createReducer(actions_1.ReduxSdkActionTypes.SetConnected),
  authenticated: helpers_1.createReducer(actions_1.ReduxSdkActionTypes.SetAuthenticated),
  account: helpers_1.createReducer(actions_1.ReduxSdkActionTypes.SetAccount),
  accountDevice: helpers_1.createReducer(actions_1.ReduxSdkActionTypes.SetAccountDevice),
  accountFriendRecovery: helpers_1.createReducer(actions_1.ReduxSdkActionTypes.SetAccountFriendRecovery),
  device: helpers_1.createReducer(actions_1.ReduxSdkActionTypes.SetDevice),
  ens: helpers_1.createReducer(actions_1.ReduxSdkActionTypes.SetEns),
  eth: helpers_1.createReducer(actions_1.ReduxSdkActionTypes.SetEth),
  incomingAction: helpers_1.createReducer(actions_1.ReduxSdkActionTypes.SetIncomingAction)
});